import { LayoutContainer, ContentWithMenu, StyledContent, StyledBox } from './style';

export const Layout = ({ children }) => <LayoutContainer>{children}</LayoutContainer>;

export { ContentWithMenu, StyledContent as Content, StyledBox as Box };
